import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=1f50f3d3"
import script from "./navigator.vue?vue&type=script&lang=js"
export * from "./navigator.vue?vue&type=script&lang=js"
import style0 from "./navigator.vue?vue&type=style&index=0&id=1f50f3d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports